// Preorder label JS placeholder.
(() => {
  const el = document.querySelector(".c-product-preorder-label");
  if (!el) return;
})();

